module.exports = __webpack_public_path__ + "img/bg_function02_3_d.d018dc71.png";